import { useState } from 'react';

import { DEFAULT_PAGE_NUMBER, MODAL_ROUTE } from '@/constants';
import { useAppDispatch } from '@/features';
import { openModal } from '@/features/slice/event/event-slice';
import { useGetExpenseCategoriesQuery } from '@/features/slice/expense/expense-api-slice';

export const useExpenseCategory = () => {
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE_NUMBER);

  const dispatch = useAppDispatch();

  const { data, isError, isLoading } = useGetExpenseCategoriesQuery({});

  const openCreateExpenseCategoryModal = () =>
    dispatch(openModal({ content: MODAL_ROUTE.CREATE_EXPENSE_CATEGORY }));

  return {
    currentPage,
    setCurrentPage,
    data,
    isError,
    isLoading,
    openCreateExpenseCategoryModal,
  };
};
